<template>
  <modal :title="`Resources ${this.resourceGroup.label}`" size="lg" ref="modal">
    <q-tabs
      v-model="tab"
      dense
      class="text-grey"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab
        v-for="resourceType in resourceTypes"
        :key="resourceType.type"
        :name="resourceType.type"
        :label="resourceType.label"
      />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel
        v-for="resourceType in resourceTypes"
        :key="resourceType.type"
        :name="resourceType.type">
        <message v-if="!resources.length">
          No {{ resourceType.label }} resources.
        </message>
        <div
          v-for="resource in resources"
          :key="resource.title"
          class="q-mb-lg">
          <resource-component :resource="resource" />
          <q-separator class="q-mt-lg" />
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import Message from '@/components/message/Message.vue';
import {
  Resource,
  ResourceType,
  ResourceGroup,
  resourceTypes,
  findByTags,
} from '.';
import ResourceComponent from './ResourceItem.vue';

interface Data {
  resourceTypes: ResourceType[],
  tab: string,
}

export default defineComponent({
  mixins: [ModalMixin],
  props: {
    resourceGroup: {
      type: Object as () => ResourceGroup,
      required: true,
    },
  },
  data(): Data {
    return {
      resourceTypes,
      tab: resourceTypes[0].type,
    };
  },
  computed: {
    resourceType(): ResourceType|undefined {
      return resourceTypes.find(rt => rt.type === this.tab);
    },
    resources(): Resource[] {
      if (!this.resourceType) return [];
      const resources = findByTags(this.resourceGroup.tags);
      return resources.filter(r => r.type === this.tab);
    },
  },
  components: {
    Message,
    Modal,
    ResourceComponent,
  },
});
</script>
